/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Next_PageInputs */

const en_common_next_page = /** @type {(inputs: Common_Next_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next page`)
};

const es_common_next_page = /** @type {(inputs: Common_Next_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página siguiente`)
};

/**
* | output |
* | --- |
* | "Next page" |
*
* @param {Common_Next_PageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_next_page = /** @type {((inputs?: Common_Next_PageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Next_PageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_next_page(inputs)
	return en_common_next_page(inputs)
});